document.addEventListener("DOMContentLoaded", function() {
  const observer = new MutationObserver(() => {
    const el = document.querySelector('#trafficly-message');
    if (el && el.textContent.includes('30 Days')) {
      el.textContent = el.textContent.replace('30 Days', '').trim();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});